import $ from 'jquery'
import {wait} from "../../../src/es6/util";

$(document).ready(async function () {
    await wait(200)
    $("[class^=autocomplete-city]").each(function () {
        let self = this;
        $(self).autocomplete();
        $(self).on("input change", function () {
            if ($('#'+self.id).val() != '') {
                $.ajax({
                    url: '/store/city-autocomplete/' + $('#'+self.id).val() + '/',
                    type: 'get',
                    cache: false,
                    data: {},
                    success: function (data) {
                        data = Object.assign({}, data.results);
                        $(self).autocomplete("updateData", data);
                    },
                    error: function (err) {
                        console.log(err);
                    }
                });
            }
        });
    });

    $("[class^=autocomplete-street]").each(function () {
        let self = this;
        $(self).autocomplete();
        $(self).on("input change", function () {
            if ($('#'+self.id).val() != '') {
                $.ajax({
                    url: '/store/street-autocomplete/' + $('#'+self.id).val() + '/',
                    type: 'get',
                    cache: false,
                    data: {},
                    success: function (data) {
                        data = Object.assign({}, data.results);
                        $(self).autocomplete("updateData", data);
                    },
                    error: function (err) {
                        console.log(err);
                    }
                });
            }
        });
    });

    $("[class^=autocomplete-post]").each(function () {
        let self = this;
        $(self).autocomplete();
        $(self).on("input change", function () {
            if ($('#'+self.id).val() != '') {
                $.ajax({
                    url: '/store/post-autocomplete/' + $('#'+self.id).val() + '/',
                    type: 'get',
                    cache: false,
                    data: {},
                    success: function (data) {
                        data = Object.assign({}, data.results);
                        $(self).autocomplete("updateData", data);
                    },
                    error: function (err) {
                        console.log(err);
                    }
                });
            }
        });
    });

    var inter_sl = {
        cancel: 'Prekini',
        clear: 'Počisti',
        done:    'Potrdi',
        previousMonth:    '‹',
        nextMonth:    '›',
        months:    [
            'Januar',
            'Februar',
            'Marec',
            'April',
            'Maj',
            'Junij',
            'Julij',
            'Avgust',
            'September',
            'Oktober',
            'November',
            'December'
        ],
        monthsShort:    [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Avg',
            'Sep',
            'Okt',
            'Nov',
            'Dec'
        ],

        weekdays:    [
            'Nedelja',
            'Ponedeljek',
            'Torek',
            'Sreda',
            'Četrtek',
            'Petek',
            'Sobota'
        ],

        weekdaysShort:    [
            'Ned',
            'Pon',
            'Tor',
            'Sre',
            'Čet',
            'Pet',
            'Sob'
        ],

        weekdaysAbbrev:    ['N', 'P', 'T', 'S', 'Č', 'P', 'S']
    }

   $(".datepicker_from").datepicker({
       format: 'dd.mm.yy',
       defaultDate: new Date(Date.now()),
       minDate: new Date(Date.now()),
       setDefaultDate: true,
       autoClose: true,
       i18n: inter_sl,
    });
   $(".datepicker_to").datepicker({
       format: 'dd.mm.yy',
       minDate: new Date(Date.now()),
       autoClose: true,
       i18n: inter_sl,
    });
});
